import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { EmailValidator, FormGroupDirective } from '@angular/forms';
import { QuotationService } from './quotation.service';
import { AppMainComponent } from '../../app.main.component';
import { MenuItem, SelectItem } from 'primeng/api';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CompactType, DisplayGrid, Draggable, GridsterConfig, GridsterItem, GridType, PushDirections, Resizable, GridsterItemComponentInterface } from 'angular-gridster2';
import { Status } from './../../models/statusEnums';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AccountService } from '../../accounts/accountService';
import { AppMainService } from '../../app-main.service';
import { DatePipe } from '@angular/common'
import { LeadService } from '../.././leads/leadService';
import { Contact } from '../../shared/shared-contacts/model/contact';
import { AutoComplete } from 'primeng/autocomplete';
import { ContactService } from '../../contacts/contactService';
import { ContactEmail, ContactPhone, ContactSocialProfile, Task, TaskStatus } from '../../shared/model/models';
import * as FileSaver from 'file-saver';


@Component({
  selector: 'app-contacts',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.scss'],
  providers: [ConfirmationService, DatePipe]
})
export class QuotationComponent implements OnInit {

  filteredCases = [];
  selectedView;
  tempContactStepBar = true;
  caseStages = [];
	caseStagesActual = [];
	caseStagesAll = [];
  curIndex = 0;
  selectedStep = 1;
  selectedStage = 0;
  selectedCaseKanban;
  globalFilterInput = "";
  noCaseFindOrLoadingText = 'Loading....';
  availableViews = [{ label: "Dashboard", value: "dashboard" }, { label: "List View", value: "list" }, { label: "Kanban View", value: "kanban" }];
  exportColumns: any[];
  options: SelectItem[];
  @ViewChild('createCase') createCase: FormGroupDirective;
  @ViewChild('createComment') createComment: FormGroupDirective;
  commentTemp = {
    "id": 0,
    "createdSource": this.app.userIP,
    "createdBy": this.app.companyId,
    "createdDate": new Date(),
    "objectId": 0,
    "objectTypeId": 0,
    "commentId": 0,
    "comment": {
      "id": 0,
      "createdSource": this.app.userIP,
      "createdBy": this.app.companyId,
      "createdDate": new Date(),
      "comment": "",
      "organizationId": this.app.companyId,
      "statusId": Status.Active,
      "isPublic": "public",
    }
  };
  caseTemp = {
    "id": 0,
    "createdSource": this.app.userIP,
    "createdBy": this.app.companyId,
    "createdDate": new Date(),
    "caseNo":0,
    "contactNameId":0,
    "contactName":"",
    "contactEmail":"",
    "contactPhone":"",
    "sourceId": 0,
    "source":{
        "id":0,
        "name":""
    },
    "categoryId":0,
    "category":{
      "id":0,
      "name":""
    },
    "subCategoryId":0,
    "subCategory":{
      "id":0,
      "name":""
    },
    "priorityId":0,
    "priority":{
      "id":0,
      "name":""
    },
    "caseStageId": 0,
    "caseStage":{
      "id":0,
      "name":""
    },
    "description": "",
    "associationNameId": 0,
    "associationName":"",
    "caseAssociationTypeId": 2,
    "caseAssociationType":{
      "id": 2,
      "createdSource": "",
      "createdBy": 0,
      "createdDate": "",
      "number": 0,
      "name":"Account"
    },
    "imageUrl":"",
    comments: [
      {
        "id": 0,
        "createdSource": this.app.userIP,
        "createdBy": this.app.companyId,
        "createdDate": new Date(),
        "objectId": 0,
        "objectTypeId": 0,
        "commentId": 0,
        "comment": {
          "id": 0,
          "createdSource": this.app.userIP,
          "createdBy": this.app.companyId,
          "createdDate": new Date(),
          "comment": "",
          "organizationId": this.app.companyId,
          "statusId": Status.Active,
          "isPublic": "public",
        }
      }
    ],
  };
  activeContactEmails = 1;
  activeContactPhones = 1;
  caseByNameCols = [
    { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
    { field: 'caseDetail', header: 'Cases', show: true, value: '', checked: true, order: false },
  ]
  menuItems;
  viewMenu;
  tempView;
  tempCols;
  tempCols2;
  tempCols3;
  caseCols2 = []
  caseCols3 = []
  selectedId;
  allStages = []
  displaySettings = false;
	tempCaseStepBar = true;
  selectedCase;
  selectedCaseFromTable = 0;
  configMenuItems;
  configMenuItemsCM;
  displayCommentAdd = false;
  showAddMore = false;
  maxNo = false;
  maxNo2 = false;
  maxNo3 = false;
  totalAmt = 0;
  totalAmt2 = 0;
  totalAmt3 = 0;
  tab;
	tab1: any
	tab2: any
	tab3: any
	tab4: any
	tab5: any
	showDiv = {
		stepsbar: false,
		views: false,
		collists: false,
		config: false,
		details: false,
    kanban: false
	}
  recentItems = [
    { label: "All Cases", code: 'all' },
    { label: "My Cases", code: 'my' },
    { label: "New last week", code: 'new last week' },
    { label: "New this week", code: 'new this week' },
    { label: "New this month", code: 'new this month' },
    { label: "Recently Viewed Cases", code: 'recent' }
  ];
  selectedRecent;
  categories = [];
  selectedCategory;
  subCates = [];
  selectedSubCate;
  priorities = []
  selectedPriority;
  sources = []
  selectedSource;
  caseAssociation = []
  selectedCaseAssociation;
  caseAssociationData = [];
  moduleName = "Organization";
  associationName;
  associationNames = [];
  allAssociationNamesList = [];
  contactNameFromAPI;
  contactNames = [];
  allContactNamesList = [];
  allContactsData = []
  allLeadsData = []
  allAccountsData = []
  orgCases = []
	comments: string;

  allCases = []
  casesData = []
  allCasesData = [];
  caseCols = []
  caseColsAll = []
  caseColsAllTemp = []
  displayCaseAdd = false;
  displayCaseEdit = false;
  displayCaseView = false;
  multiLineTooltip = `<ul class="p-mt-0 p-pl-4 p-mb-0">
            <li>Files with extensions: gif, png, jpg, jpeg, pdf, txt, xls, xlsx, doc, docx, ppt, pptx are allowed</li>
            </ul>`;

  constructor(
    public app: AppMainComponent,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private quotationService: QuotationService,
    private accountService: AccountService,
    public datepipe: DatePipe,
    private leadService: LeadService,
    private contactService: ContactService,
  ) { }

  ngOnInit() {

    this.configMenuItems = [
      {
        label: 'View',
        icon: 'pi pi-list',
        command: () => {
          this.showViewCase({ id: this.selectedCase.id });
        }
      },
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => {
          this.showEditCase({ id: this.selectedCase.id });
        }
      },
      {
        label: 'Delete',
        icon: 'pi pi-trash',
        command: () => {
          this.deleteCase({ id: this.selectedCase.id });
        }
      }
    ];
    this.configMenuItemsCM = [
      {
        label: 'View',
        icon: 'pi pi-list',
        command: () => {
          this.showViewCase({ id: this.selectedCase.id });
        }
      },
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => {
          this.showEditCase({ id: this.selectedCase.id });
        }
      },
      {
        label: 'Delete',
        icon: 'pi pi-trash',
        command: () => {
          this.deleteCase({ id: this.selectedCase.id });
        }
      }
    ];

    this.options = [{label: 'Private', value: 'private'}, {label: 'Public', value: 'public'}];

    this.quotationService.getLoggedUser(this.app.userId).then(user => {
      this.app.currentUser = user;
      this.selectedView = this.app.currentUser.contactDefaultView;
      this.buildMenuBar(this.selectedView, 0);
    });

    this.caseCols3 = [
      { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, move:false },
      { field: 'caseNo', header: 'Case No.', show: true, value: '', checked: true, order: false, move:false },
      { field: 'caseAssociation', header: 'Association Type', show: true, value: '', checked: true, order: false, move:false },
      { field: 'assoName', header: 'Association Name', show: true, value: '', checked: true, order: false, move:false },
      { field: 'conName', header: 'Contact Name', show: true, value: '', checked: true, order: false, move:true },
      { field: 'category', header: 'Category', show: true, value: '', checked: true, order: false, move:true },
      { field: 'subCate', header: 'Sub Category', show: true, value: '', checked: true, order: false, move:true },
      { field: 'source', header: 'Contact Source', show: false, value: '', checked: false, order: false, move:true },
      { field: 'email', header: 'Contact Email', show: false, value: '', checked: false, order: false, move:true },
      { field: 'phone', header: 'Contact Number', show: false, value: '', checked: false, order: false, move:true },
      { field: 'desc', header: 'Decription', show: false, value: '', checked: false, order: false, move:true },
    ];

    this.caseCols2 = [
      { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
      { field: 'caseNo', header: 'Case No.', show: true, value: '', checked: true, order: false },
      { field: 'conName', header: 'Contact Name', show: true, value: '', checked: true, order: false },
      { field: 'assoName', header: 'Association Name', show: true, value: '', checked: true, order: false },
      { field: 'caseAssociation', header: 'Association Type', show: false, value: '', checked: false, order: false },
      { field: 'source', header: 'Contact Source', show: false, value: '', checked: false, order: false },
      { field: 'email', header: 'Contact Email', show: true, value: '', checked: true, order: false },
      { field: 'phone', header: 'Contact Number', show: false, value: '', checked: false, order: false },
      { field: 'category', header: 'Category', show: true, value: '', checked: true, order: false },
      { field: 'subCate', header: 'Sub Category', show: true, value: '', checked: true, order: false },
      { field: 'desc', header: 'Decription', show: false, value: '', checked: false, order: false },
    ];

    this.caseCols = [
      { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
      { field: 'caseNo', header: 'Case No.', show: true, value: '', checked: true, order: false },
      { field: 'conName', header: 'Contact Name', show: true, value: '', checked: true, order: false },
      { field: 'assoName', header: 'Association Name', show: true, value: '', checked: true, order: false },
      { field: 'caseAssociation', header: 'Association Type', show: false, value: '', checked: false, order: false },
      { field: 'source', header: 'Contact Source', show: false, value: '', checked: false, order: false },
      { field: 'email', header: 'Contact Email', show: true, value: '', checked: true, order: false },
      { field: 'phone', header: 'Contact Number', show: true, value: '', checked: true, order: false },
      { field: 'category', header: 'Category', show: true, value: '', checked: true, order: false },
      { field: 'subCate', header: 'Sub Category', show: true, value: '', checked: true, order: false },
      { field: 'desc', header: 'Decription', show: false, value: '', checked: false, order: false },
    ];

    this.caseColsAll = JSON.parse(JSON.stringify(this.caseCols));

    this.getAllCases();

    this.quotationService.getAllContactSource(this.app.companyId).then(sources => {
      this.sources = sources;
    });

    this.contactService.getAllContactAssociation().then(asso => {
      this.caseAssociation = asso;
      this.updateCaseAssociation();
    });

    this.quotationService.getAllCategory().then(cates => {
      this.categories = cates;
    });

    this.quotationService.getAllSubCategory().then(cates => {
      this.subCates = cates;
    });

    this.quotationService.getAllPirority().then(pri => {
      this.priorities = pri;
    });

  }

  updateCaseAssociation() {
    let index = this.caseAssociation.findIndex(el => el.name === this.moduleName);
    if (index > -1) {
      this.selectedCaseAssociation = this.caseAssociation[index];
      this.getValues();
      //this.contactTemp.associationId = this.associationName.id;
    }
  }

  addItem(option: any, autoCompleteComponent: AutoComplete) {
    autoCompleteComponent.el.nativeElement.value = '';
    autoCompleteComponent.value = autoCompleteComponent.value || [];
    if (!autoCompleteComponent.isSelected(option)) {
      autoCompleteComponent.value = [...autoCompleteComponent.value, option];
      autoCompleteComponent.onModelChange(autoCompleteComponent.value);
    }

    autoCompleteComponent.onSelect.emit(option);
    autoCompleteComponent.el.nativeElement.focus();
  }
  getValues(){
    this.associationName = {};
    if(this.selectedCaseAssociation.name == "Lead"){
      this.getAllLeads();
    } else if (this.selectedCaseAssociation.name == "Account"){
      this.getAllAccounts();
    }  else if (this.selectedCaseAssociation.name == "Organization"){
      this.allAssociationNamesList = [
        { id:0, businessName:this.app.companyName }
      ]
    }
  }
  getAllLeads() {
    let pageSize = 100;
    let pageNumber = 1;
    this.leadService.getAllLeads(pageSize, pageNumber, this.app.companyId,0).then(responseData => {
      const { leads, headers }= responseData;
      this.allLeadsData = []
      this.allAssociationNamesList = []
      for (let l of leads) {
        let eachLead = {
          id: Number(l.id + ""),
          businessName: l.businessName,
        }
        this.allLeadsData.push(eachLead);
      }
      this.allLeadsData.sort((a, b) => (b.id - a.id));
      this.allAssociationNamesList = [];
      this.allAssociationNamesList = JSON.parse(JSON.stringify(this.allLeadsData));
    });
  }
  getAllAccounts() {
    let data =  {
      currentPage: 1,
      pageSize: 100,
      organizationId: this.app.companyId ,
      loginUserId: 9
  }
    this.accountService.getAllAccounts(data).then(accounts => {
      this.allAccountsData = []
      this.allAssociationNamesList = []
      for (let l of accounts) {
        let eachAccount = {
          id: Number(l.id + ""),
          businessName: l.businessName,
        }
        this.allAccountsData.push(eachAccount);
      }
      this.allAccountsData.sort((a, b) => (b.id - a.id));
      this.allAssociationNamesList = [];
      this.allAssociationNamesList = JSON.parse(JSON.stringify(this.allAccountsData));
    });
  }
  search(query) {
    let filtered: any[] = [];
    for (let i of this.allAssociationNamesList) {
      let associationName = i;
      if (associationName.businessName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(associationName);
      }
    }
    this.associationNames = filtered;
  }

  searchContact(query) {
    let filtered: any[] = [];
    let pageSize = 100;
    let pageNumber = 1;
    this.contactService.getContactList({pageSize: pageSize,pageNumber: pageNumber} as any).subscribe(responseData => {
      let { contacts, headers } = responseData;
      contacts = contacts == null ? [] : contacts;
      headers = headers == null ? [] : headers;
      this.allContactsData = []
      this.allContactNamesList = []
      for (let l of contacts) {
        let eachContact = {
          id: Number(l.id + ""),
          businessName: l.firstName + " " + l.lastName,
          email: l.contactEmails && l.contactEmails[0] && l.contactEmails[0].email ? l.contactEmails[0].email.emailAddress : null,
          phone: l.contactPhones && l.contactPhones[0] && l.contactPhones[0].phone ? l.contactPhones[0].phone.number : null,
        }
        this.allContactsData.push(eachContact);
      }
      this.allContactsData.sort((a, b) => (b.id - a.id));
      this.allContactNamesList = [];
      this.allContactNamesList = JSON.parse(JSON.stringify(this.allContactsData));
      this.caseTemp.contactEmail = this.contactNameFromAPI ? this.contactNameFromAPI.email : "";
      this.caseTemp.contactPhone = this.contactNameFromAPI ? this.contactNameFromAPI.phone : "";
    });
    for (let i of this.allContactNamesList) {
      let contactNameFromAPI = i;
      if (contactNameFromAPI.businessName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(contactNameFromAPI);
      }
    }
    this.contactNames = filtered;
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key == "Enter" || event.key == "Tab") {
      let tokenInput = event.srcElement as any;
      if (tokenInput.value) {
        let obj = this.allAssociationNamesList.filter(r => r.name.toLowerCase().startsWith(tokenInput.value.toLowerCase()))[0];
        this.caseTemp.associationName = this.app.copyObjectWithoutRefrence(obj);
        tokenInput.value = "";
      }
      let tokenInput2 = event.srcElement as any;
      if (tokenInput2.value) {
        let obj = this.allContactNamesList.filter(r => r.name.toLowerCase().startsWith(tokenInput2.value.toLowerCase()))[0];
        this.caseTemp.contactName = this.app.copyObjectWithoutRefrence(obj);
        tokenInput2.value = "";
      }
    }
  }

  onKeyUp1(event: KeyboardEvent) {
    if (event.key == "Enter" || event.key == "Tab") {
      let tokenInput = event.srcElement as any;
      if (tokenInput.value) {
        let obj = this.allAssociationNamesList.filter(r => r.name.toLowerCase().startsWith(tokenInput.value.toLowerCase()))[0];
        this.caseTemp.associationName = this.app.copyObjectWithoutRefrence(obj);
        tokenInput.value = "";
      }
      let tokenInput2 = event.srcElement as any;
      if (tokenInput2.value) {
        let obj = this.allContactNamesList.filter(r => r.name.toLowerCase().startsWith(tokenInput2.value.toLowerCase()))[0];
        this.caseTemp.contactName = this.app.copyObjectWithoutRefrence(obj);
        tokenInput2.value = "";
      }
    }
  }

  importContacts() {
  }

  exportFilter(value, args) {
		if (!value) return null;
		if (!args) return value;

		args = args.toLowerCase();

		return value.filter(function (item) {
			return JSON.stringify(item).toLowerCase().includes(args);
		});
	}

  exportFilterByCol(value, args, field) {
		if (!value) return null;
		if (!args) return value;

		args = args.toLowerCase();

		return value.filter(function (item) {
			return JSON.stringify(item[field]).toLowerCase().includes(args);
		});
	}

  exportContacts(){
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
			let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
			let EXCEL_EXTENSION = '.xlsx';
			const data: Blob = new Blob([buffer], {
				type: EXCEL_TYPE
			});
			FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
	}

  buildMenuBar(view, i) {
    this.selectedView = view;
    if (this.selectedView == 'list')
      this.caseCols = this.caseColsAll;
    this.globalFilterInput = "";

    let dashlab = (this.app.currentUser.casesDefaultView == "dashboard") ? 'Dashboard <i title="Default View" class="pi pi-eye menuDefault"></i>' : 'Dashboard';
    let listlab = (this.app.currentUser.casesDefaultView == "list") ? 'List View <i title="Default View" class="pi pi-eye menuDefault"></i>' : 'List View';
    let kanbanlab = (this.app.currentUser.casesDefaultView == "kanban") ? 'Kanban View <i title="Default View" class="pi pi-eye menuDefault"></i>' : 'Kanban View';
    let items = [
        {
            label: dashlab,
            escape: false,
            icon: 'pi pi-chart-bar',
            command: (event) => this.buildMenuBar("dashboard", 0)
        },
        {
            label: listlab,
            escape: false,
            icon: 'pi pi-align-justify',
            command: (event) => this.buildMenuBar("list", 0)
        },
        {
            label: kanbanlab,
            escape: false,
            icon: 'pi pi-sliders-v',
            command: (event) => this.buildMenuBar("kanban", 0)
        }
    ];
    let viewMenu;
    if (view === 'dashboard') {
        this.selectedCase = null;
        this.selectedCaseKanban = null;
        viewMenu = {
            label: 'Dashboard',
            icon: 'pi pi-chart-bar',
            items: items
        };
    } else if (view === 'list') {
        this.selectedCase = null;
        this.selectedCaseKanban = null;
        this.kanbanSelectedStage = null;
			  this.caseStages = JSON.parse(JSON.stringify(this.caseStagesActual));

        this.selectedStep = i + 1;
        this.stepClicked(i, this.selectedStage)
        viewMenu = {
            label: 'List',
            icon: 'pi pi-align-justify',
            items: items
        };
    } else if (view === 'kanban') {
      this.selectedCase = null;
			this.selectedCaseKanban = null;
			this.kanbanSelectedStage = null;
			this.caseStages = JSON.parse(JSON.stringify(this.caseStagesActual));

			this.deselectStages();
			viewMenu = {
				label: 'Kanban',
				icon: 'pi pi-sliders-v',
				items: items
			};
    }

    this.menuItems = [
      {
        label: 'New',
        icon: 'pi pi-plus',
        command: (event) => this.newContact()
      },
      {
        label: 'Import',
        icon: 'pi pi-download',
        command: (event) => this.importContacts()
      },
      {
        label: 'Export',
        icon: 'pi pi-upload',
        command: (event) => this.exportContacts()
      },
      viewMenu,
      {
        label: 'Settings',
        icon: 'pi pi-cog ',
        command: (event) => this.settings()
      }
    ];

    this.getAllStages();
  }

  backListView() {
    this.selectedCase = null;
    this.selectedView = 'list';
    this.caseColsAll = this.caseColsAllTemp;
    this.caseCols = this.caseColsAll;
    this.caseStages = this.caseStagesActual;
  }

  getAllStages() {
    this.quotationService.getAllStages().then(stages => {
      this.allStages = stages;
    });
  }
  deselectStages() {
		this.selectedStep = null;
		this.selectedStage = null;
		this.selectedCase = null;
	}

  onRowSelect() {
    if (this.selectedCase.caseStageId == null) {
			this.curIndex = 0;
		} else {
			this.curIndex = this.selectedCase.caseStageId;
		}

    this.selectedCase
    this.filteredCases = [...this.casesData.filter(p => p.id == this.selectedCase.id)];

    this.app.objectId = this.selectedCase.id;
    this.selectedId = this.selectedCase.id;
    this.app.objectType = "Contact";
    this.selectedCaseFromTable = this.selectedCase.id;
    this.caseColsAllTemp = this.caseColsAll;
  }

  getAllCases() {
    this.quotationService.getAllStages().then(stages => {
      stages = stages.filter(e => e.visibility);
			stages = stages.sort((a, b) => a.displayOrder - b.displayOrder);
			this.allStages = JSON.parse(JSON.stringify(stages));
			let tempStages = stages;

      this.quotationService.getAllCases().then(cases => {
        this.allCases = JSON.parse(JSON.stringify(cases));
        this.allCasesData = []
        this.casesData = []
        this.orgCases = []
        for (let l of cases) {
          if(l.caseAssociationTypeId === 46){
            this.orgCases.push(l);
          }

          let caseStage = "";
					for (let ss of tempStages) {
						if (ss.id == l.caseStageId) {
							caseStage = ss.name;
						}
					}

          let eachContact = {
            id: l.id,
            conName: l.contactName,
            email: l.contactEmail,
            phone: l.contactPhone,
            caseNo: l.caseNo,
            caseDetail: l.caseNo + " - " + (l.category ? l.category.name : null),
            source: l.source ? l.source.name : null,
            caseStageId: l.caseStageId,
            caseStage: caseStage,
            categoryId: l.categoryId,
            category: l.category ? l.category.name : null,
            subCateId: l.subCategoryId,
            subCate: l.subCategory ? l.subCategory.name : null,
            priorityId: l.priorityId,
            priority: l.priority ? l.priority.name : null,
            caseAssociation: l.caseAssociationType ? l.caseAssociationType.name : null,
            caseAssociationId: l.caseAssociationTypeId,
            assignedToUserId: l.assignedToUserId,
            assoName: l.associationName,
            createdDate: new Date(),
            imageUrl:l.imageUrl,
            desc: l.comments && l.comments[0] && l.comments[0].comment ? l.comments[0].comment.comment : null,
            comments: l.comments,
          }
          this.allCasesData.push(eachContact);
        }
        this.allCasesData.sort((a, b) => (b.id - a.id));
        this.casesData = JSON.parse(JSON.stringify(this.allCasesData));

        // this.recentUpdate();
        this.filterStagesData(tempStages, this.casesData);
        if (this.selectedView === 'kanban') {
					this.selectKanbanItem(this.selectedCase, this.kanbanSelectedStage);
				}


      }).finally(() => {
        this.noCaseFindOrLoadingText = 'No contacts found.';
      });
    })
  }

  newContact() {
    this.caseTemp = {
      "id": 0,
      "createdSource": this.app.userIP,
      "createdBy": this.app.companyId,
      "createdDate": new Date(),
      "caseNo":0,
      "contactNameId":0,
      "contactName":"",
      "contactEmail":"",
      "contactPhone":"",
      "sourceId": 0,
      "source":{
        "id":0,
        "name":""
      },
      "categoryId":0,
      "category":{
        "id":0,
        "name":""
      },
      "subCategoryId":0,
      "subCategory":{
        "id":0,
        "name":""
      },
      "priorityId":0,
      "priority":{
        "id":0,
        "name":""
      },
      "caseStageId": 0,
      "caseStage":{
        "id":0,
        "name":""
      },
      "description": "",
      "associationNameId": 0,
      "associationName": "",
      "caseAssociationTypeId": 0,
      "caseAssociationType":{
        "id": 0,
        "createdSource": "",
        "createdBy": 0,
        "createdDate": "",
        "number": 0,
        "name":""
      },
      "imageUrl":"https://d2pawxljps4e1j.cloudfront.net/SF2Static/Content/image/note_icon.png",
      comments: [
        {
          "id": 0,
          "createdSource": this.app.userIP,
          "createdBy": this.app.companyId,
          "createdDate": new Date(),
          "objectId": 0,
          "objectTypeId": 0,
          "commentId": 0,
          "comment": {
            "id": 0,
            "createdSource": this.app.userIP,
            "createdBy": this.app.companyId,
            "createdDate": new Date(),
            "comment": "",
            "organizationId": this.app.companyId,
            "statusId": Status.Active,
            "isPublic": "public",
          }
        }
      ],
    };
    this.displayCaseAdd = true;
  }

  saveCase() {
    let caseData = JSON.parse(JSON.stringify(this.caseTemp));

    caseData.organizationId = this.app.companyId;
    caseData.statusId = Status.Active;
    caseData.caseNo = caseData.id;

    caseData.sourceId = this.selectedSource ? this.selectedSource.id : null;
    caseData.caseStageId = null;
    caseData.categoryId = this.selectedCategory ? this.selectedCategory.id : null;
    caseData.category.name = this.selectedCategory ? this.selectedCategory.name : null;
    caseData.subCategoryId = this.selectedSubCate ? this.selectedSubCate.id : null;
    caseData.subCategory.name = this.selectedSubCate ? this.selectedSubCate.name : null;
    caseData.priorityId = this.selectedPriority ? this.selectedPriority.id : null;
    caseData.priority.name = this.selectedPriority ? this.selectedPriority.name : null;
    caseData.caseAssociationTypeId = this.selectedCaseAssociation ? this.selectedCaseAssociation.id : null;
    caseData.caseAssociationType.name = this.selectedCaseAssociation ? this.selectedCaseAssociation.name : null;
    caseData.associationId = this.associationName ? this.associationName.id : null;
    caseData.associationName = this.associationName ? this.associationName.businessName : null;
    caseData.contactNameId = this.contactNameFromAPI ? this.contactNameFromAPI.id : null;
    caseData.contactName = this.contactNameFromAPI ? this.contactNameFromAPI.businessName : null;

    this.quotationService.addCase(caseData).then(() => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact saved successfully...' });
      this.quotationService.getAllStages().then(stages => {
        this.getAllCases();
        this.caseStages = stages;
      });
      this.displayCaseAdd = false;
    }).catch(() => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
    });
  }

  cancelAddCase() {
    this.createCase.form.reset();
    this.displayCaseAdd = false;
  }

  deleteCase({ id }) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Contact?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.quotationService.deleteCase(id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.getAllCases();
          if (this.selectedView == 'split'){
            this.selectedView = 'list';
          }
          this.caseCols = this.caseColsAll;
          this.selectedCase = null;
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  showEditCase({ id }) {
    let thisCase;

    this.quotationService.getCaseById(id).then((contact: Contact) => {
      thisCase = JSON.parse(JSON.stringify(contact));

      this.selectedSource = thisCase.sourceId && thisCase.sourceId > 0 ? this.sources.filter(elem => elem.id === thisCase.sourceId)[0] : this.sources[0];
      this.associationName = thisCase.associationId && thisCase.associationId > 0 ? this.allAssociationNamesList.filter(elem => elem.id === thisCase.associationId)[0] : this.allAssociationNamesList[0];
      this.contactNameFromAPI = thisCase.contactNameId && thisCase.contactNameId > 0 ? this.allContactNamesList.filter(elem => elem.id === thisCase.contactNameId)[0] : this.allContactNamesList[0];

      this.caseTemp = JSON.parse(JSON.stringify(thisCase));
      this.displayCaseEdit = true;
      this.displayCaseView = false;
    })
  }

  updateEditContact() {
    let caseData = JSON.parse(JSON.stringify(this.caseTemp));

    caseData.createdBy = this.app.companyId;
    caseData.updatedBy = this.app.companyId;
    caseData.updatedDate = new Date();
    caseData.updatedSource = this.app.userIP;
    caseData.caseNo = caseData.id;
    caseData.sourceId = this.selectedSource ? this.selectedSource.id : null;
    caseData.caseStageId = caseData.caseStageId !== 0 ? caseData.caseStageId : null;
    caseData.categoryId = this.selectedCategory ? this.selectedCategory.id : null;
    caseData.category.name = this.selectedCategory ? this.selectedCategory.name : null;
    caseData.subCategoryId = this.selectedSubCate ? this.selectedSubCate.id : null;
    caseData.subCategory.name = this.selectedSubCate ? this.selectedSubCate.name : null;
    caseData.priorityId = this.selectedPriority ? this.selectedPriority.id : null;
    caseData.priority.name = this.selectedPriority ? this.selectedPriority.name : null;
    caseData.caseAssociationTypeId = this.selectedCaseAssociation ? this.selectedCaseAssociation.id : null;
    caseData.caseAssociationType.name = this.selectedCaseAssociation ? this.selectedCaseAssociation.name : null;
    caseData.associationId = this.associationName ? this.associationName.id : null;
    caseData.associationName = this.associationName ? this.associationName.businessName : null;
    caseData.contactNameId = this.contactNameFromAPI ? this.contactNameFromAPI.id : null;
    caseData.contactName = this.contactNameFromAPI ? this.contactNameFromAPI.businessName : null;


    this.quotationService.updateCase(caseData).then(() => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact updated successfully...' });
      this.getAllCases();
      if (this.selectedView == 'split'){
        this.backListView();
      }
      this.displayCaseEdit = false;
    }).catch(() => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
    });
  }

  recentUpdate() {
    if (this.selectedRecent.code == 'my') {
      this.casesData = this.casesData.filter(e => e.assignedToUserId === this.app.currentUser.id);
    } else if (this.selectedRecent.code == 'birthday') {
      // to do
    } else if (this.selectedRecent.code == 'new last week') {
      this.casesData = this.casesData.filter(e => !e.caseStageId);
    } else if (this.selectedRecent.code == 'new this week') {
      // to do
    } else if (this.selectedRecent.code == 'new this month') {
      // to do
    } else if (this.selectedRecent.code == 'all') {
      this.casesData = this.allCasesData;
    } else if (this.selectedRecent.code == 'recent') {
      // to do
    }
  }

  settings() {
    this.tempView = JSON.parse(JSON.stringify(this.app.currentUser.casesDefaultView));
		this.tempCaseStepBar = JSON.parse(JSON.stringify(this.app.currentUser.casesStepBar));
    this.tempCols = JSON.parse(JSON.stringify(this.caseCols));
    this.tempCols2 = JSON.parse(JSON.stringify(this.caseCols2));
    this.tempCols3 = JSON.parse(JSON.stringify(this.caseCols3));

    if(this.selectedView == 'list'){
			this.tab = 'tab3';
			this.showDiv = {
				stepsbar: false,
				views: false,
				collists: true,
				config: false,
				details: false,
        kanban: false
			}
		} else if(this.selectedView == 'split'){
			this.tab = 'tab4';
			this.showDiv = {
				stepsbar: false,
				views: false,
				collists: false,
				config: false,
				details: true,
        kanban: false
			}
		} else if(this.selectedView == 'kanban'){
      this.tab = 'tab5';
      this.showDiv = {
        stepsbar: false,
        views: false,
        collists: false,
        config: false,
        details: false,
        kanban: true
      }
    }

    for (let col of this.tempCols) {
      if (col.checked == true) { this.totalAmt++; }
    }
    this.totalAmt === 7 ? (this.maxNo = true) : (this.maxNo = false);

    for (let col of this.tempCols2) {
      if (col.checked == true) { this.totalAmt2++; }
    }
    this.totalAmt2 === 6 ? (this.maxNo2 = true) : (this.maxNo2 = false);

    for (let col of this.tempCols3) {
      if (col.checked == true) { this.totalAmt3++; }
    }
    this.totalAmt3 === 6 ? (this.maxNo3 = true) : (this.maxNo3 = false);

    this.displaySettings = true;
  }

  saveSettings() {
    for (let col of this.tempCols) {
      if (col.checked == true) {
        col.show = true;
      } else { col.show = false; }
    }
    for (let col of this.tempCols2) {
      if (col.checked == true) {
        col.show = true;
      } else { col.show = false; }
    }
    for (let col of this.tempCols3) {
      if (col.checked == true) {
        col.show = true;
      } else { col.show = false; }
    }
    this.caseCols = JSON.parse(JSON.stringify(this.tempCols));
    this.caseColsAll = JSON.parse(JSON.stringify(this.tempCols));
    this.caseCols2 = JSON.parse(JSON.stringify(this.tempCols2));
    this.caseCols3 = JSON.parse(JSON.stringify(this.tempCols3));
    this.quotationService.updateUser(this.app.currentUser);
		this.app.currentUser.casesStepBar = this.tempCaseStepBar;
    //this.app.currentUser.contactDefaultView = this.tempView;
    //this.buildMenuBar(this.app.currentUser.contactDefaultView, 0);
    this.totalAmt = 0;
    this.totalAmt2 = 0;
    this.totalAmt3 = 0;
    this.displaySettings = false;
  }

  onClick(check) {
    if (check == 1) { this.tab = 'tab1'; }
    else if (check == 2) { this.tab = 'tab2'; }
    else if (check == 3) { this.tab = 'tab3' }
    else if (check == 4) { this.tab = 'tab4' }
    else if (check == 5) { this.tab = 'tab5' }
    else if (check == 6) { this.tab = 'tab6' }
  }

  drop(event: CdkDragDrop<string[]>) {
		let item = <any>event.previousContainer.data[event.previousIndex];
		item.caseStageId = event.container.id;
		this.updateStage(event, item);
	}

  dropCol(event: CdkDragDrop<string[]>) {
    if (event.currentIndex > 0)
      moveItemInArray(this.tempCols, event.previousIndex, event.currentIndex);
      moveItemInArray(this.tempCols2, event.previousIndex, event.currentIndex);
      moveItemInArray(this.tempCols3, event.previousIndex, event.currentIndex);
  }

  onChange(isChecked: boolean) {
    if (isChecked) this.totalAmt++;
    else this.totalAmt--;
    this.totalAmt === 7 ? (this.maxNo = true) : (this.maxNo = false);
  }

  onChange2(isChecked: boolean) {
    if (isChecked) this.totalAmt2++;
    else this.totalAmt2--;
    this.totalAmt2 === 6 ? (this.maxNo2 = true) : (this.maxNo2 = false);
  }

  onChange3(isChecked: boolean) {
    if (isChecked) this.totalAmt3++;
    else this.totalAmt3--;
    this.totalAmt3 === 6 ? (this.maxNo3 = true) : (this.maxNo3 = false);
  }

  stepClicked(i, id) {
    this.globalFilterInput = "";
    if (this.selectedView == 'kanban' || this.selectedView == 'dashboard') {
        this.selectedView = 'list';
        this.buildMenuBar(this.selectedView, i);
    }
    this.selectedStep = i + 1;
		this.selectedStage = id;
		for (let es of this.caseStages) {
			if (i == 0) {
				this.casesData = this.allCasesData;
			} else if (es.id == id) {
				this.casesData = es.cases;
			}
		}
  }

  updateCurrentStage(i, id) {
		let oneCase = {
			id: 0,
			caseStageId: id
		};
		oneCase.id = this.allCases.filter(elem => elem.id === this.selectedCase.id)[0].id;

		this.quotationService.updateCaseStage(oneCase).then(() => {
			this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Stage updated successfully...' });
			this.curIndex = i+1;
			this.getAllCases();
			if (this.selectedView == 'kanban') {
				this.selectedCase = null;
				this.selectedCaseKanban = null;
				this.caseStages = JSON.parse(JSON.stringify(this.caseStagesActual));
			}
		}).catch(() => {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
		});
	}

	updateStage(event, item) {
		let oneCase = {
			id: item.id,
			caseStageId: item.caseStageId
		};

		this.quotationService.updateCaseStage(oneCase).then(() => {
			this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Stage updated successfully...' });

			if (event.previousContainer === event.container) {
				moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

			} else {
				transferArrayItem(event.previousContainer.data,
					event.container.data,
					event.previousIndex,
					event.currentIndex);
			}

			this.getAllCases();
		}).catch(() => {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
		});
	}

  kanbanSelectedStage = null;

  kanbanItemClicked(item, stage) {
    if (this.selectedCase && item.id == this.selectedCase.id) {
        this.selectedCase = null;
        this.selectedCaseKanban = null;
        this.kanbanSelectedStage = null;
        this.caseStages = JSON.parse(JSON.stringify(this.caseStagesActual));
    } else {
        this.selectKanbanItem(item, stage);
    }
}

selectKanbanItem(item, stage) {
    this.selectedCase = item;
    this.onRowSelect();
    this.kanbanSelectedStage = stage;
    if (stage.id) {
        let temp = [];
        for (let s of this.caseStagesActual) {
            if (s.id == stage.id)
                temp.push(s);
        }
        this.caseStages = JSON.parse(JSON.stringify(temp));
    }
    else {
        let temp = [];
        for (let s of this.caseStagesActual) {
            if (!s.id)
                temp.push(s);
        }
        this.caseStages = JSON.parse(JSON.stringify(temp));
    }
}

  filterStagesData(tempStages, cases) {
    this.caseStagesAll = [{ id: 0, name: "All Cases", cases: this.casesData }];
    let thiscaseStages = [];
    let color1 = '#b3afafd9';
		let color2 = '#30f558';
		let color3 = '#f5c330';
		let color4 = '#00afac';
		let color5 = '#036bb6';

    for (let es of tempStages) {
			const stageCases = cases.filter(oneCase => oneCase.caseStageId === es.id);
			es.leads = stageCases;
      if (es.id == 1)
				es.color = color1;
			if (es.id == 2)
				es.color = color2;
			if (es.id == 3)
				es.color = color3;
			if (es.id == 4)
				es.color = color4;
        if (es.id == 5)
				es.color = color5;
			this.caseStagesAll.push(es);
		}

    for (let es of tempStages) {
      if (es.name == "Open") {
				const stageCases = cases.filter(oneCase => !oneCase.caseStageId || oneCase.caseStageId === es.id);
				es.cases = stageCases;
				thiscaseStages.push(es);
			} else {
				const stageCases = cases.filter(oneCase => oneCase.caseStageId === es.id);
				es.cases = stageCases;
				thiscaseStages.push(es);
			}
    }

    this.caseStages = JSON.parse(JSON.stringify(thiscaseStages));
		this.caseStagesActual = JSON.parse(JSON.stringify(thiscaseStages));
  }

  showViewCase({ id }) {
    let thisCase;

    this.quotationService.getCaseById(id).then((contact: Contact) => {
      thisCase = JSON.parse(JSON.stringify(contact));

      this.selectedSource = thisCase.sourceId && thisCase.sourceId > 0 ? this.sources.filter(elem => elem.id === thisCase.sourceId)[0] : this.sources[0];
      this.selectedCaseAssociation = thisCase.caseAssociationTypeId && thisCase.caseAssociationTypeId > 0 ? this.caseAssociation.filter(elem => elem.id === thisCase.caseAssociationTypeId)[0] : this.caseAssociation[0];

      this.caseTemp = JSON.parse(JSON.stringify(thisCase));
      this.displayCaseView = true;
    })
  }

  showAddComment({id}){
    this.quotationService.getCaseById(id).then((contact: Contact) => {
      this.caseTemp = JSON.parse(JSON.stringify(contact));
      this.displayCommentAdd = true;

    })
  }

  addComment() {
    if(this.createComment.form.valid) {
      this.selectedCase.comments.push(this.commentTemp);
      this.displayCommentAdd = false;
    }
  }

}
